import { render, staticRenderFns } from "./UseStandard.vue?vue&type=template&id=e9d2be8c&scoped=true&"
import script from "./UseStandard.vue?vue&type=script&lang=js&"
export * from "./UseStandard.vue?vue&type=script&lang=js&"
import style0 from "./UseStandard.vue?vue&type=style&index=0&id=e9d2be8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d2be8c",
  null
  
)

export default component.exports